<template>
  <div id="app">
    <div v-if="!loginview">

      <tnav :titleval="ttlval" app fixed v-show="topbarshow"></tnav>
    <div id="nav" ></div>
    <router-view/>
      
<div id="spcr"></div>
    <bnav></bnav>
    </div>
     <div v-if="loginview" v-bind:style="{ backgroundImage: 'url(' + bg + ')' }">
       <form style="padding:1em; height:100vh;background: #00000085;    color: #e9ecef;">
           
           
            <div style="    text-align: center;"><img :src="logimg"></div>


            <div class="form-group" style="text-align: left;">
                <label>Email address</label>
                <input type="email" class="form-control form-control-lg" />
            </div>

            <div class="form-group" style="text-align: left;">
                <label>Password</label>
                <input type="password" class="form-control form-control-lg" />
            </div>

            <button type="submit" class="btn btn-dark btn-lg btn-block">Sign In</button>

            <p class="forgot-password text-right mt-2 mb-4">
                <!-- <router-link to="/forgot-password">Forgot password ?</router-link> -->
            </p>

            

        </form>
     </div>
    
  </div>
  
</template>
<script>
import Vue from 'vue'

// @ is an alias to /src
import bnav from '@/components/BottomNav'
import tnav from '@/components/Topbr'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/messaging'
// Vue.prototype.$bURL = 'http://eademoapi.linkwayapps.com/api/'
Vue.prototype.$bURL = 'https://linkwayapps.com/api/'
Vue.prototype.cartitem = []
Vue.prototype.seach =''


export default {
    components: {
      
        bnav,tnav
        
       },
  
  data () {
    return {
      logimg:require('./assets/login.png'),
      bg:require('./assets/logbg.jpg'),
      ttlval:'',
      item :'',
      itemcountnumber:'',
      topbarshow:true,
      sechshow:false,
      searchval:'',
      catname:'',
      subcatname:'',
      addedcartitem:[],
      checkout:[],
      loginview:''
     

       
    }
  },
  watch: {
    itemcountnumber: function(newValue, oldValue) {
      //console.log(newValue, oldValue)
       this.$parent.$children[0].$children[0].cartlength = newValue
     
    },
    
      searchval: function(newValue, oldValue) {
      //console.log(newValue, oldValue)
       this.$parent.$children[0].$children[0].prntsearch = newValue
     
    },
    catname: function(newValue, oldValue) {
      console.log(this.$parent.$children[0].category)
      this.$parent.$children[0].$children[0].category = newValue
      //  this.$parent.$children[0].$children[0].prntsearch = newValue
      //  Router.push('/catogory');
    }

  },
  mounted() {
    const config = {

  messagingSenderId: "1036315032673",
  storageBucket: "firepro-30e2c.appspot.com",
  apiKey: "AIzaSyBG8NR1qkSDU1EL17Wjg_0jGYRjOzi_Uqc",
  authDomain: "fire-chat-93370.firebaseapp.com",
  projectId: "firepro-30e2c",
  databaseURL: "https://fire-chat-93370.firebaseio.com",
  appId: "1:1036315032673:web:6b276a229c7862a4bfbe20",
    }
    firebase.initializeApp(config)

    const messaging = firebase.messaging()

    messaging.usePublicVapidKey("BKr_Wpdeq75Xav5sA1GhRQHsaPf3rTdUy62DAzp13tlJ8DUcpCo2AIJh2lhhpf5pcAxRT2k0KINyUyAhPlYAulY")

    messaging.requestPermission().then(() => {
      console.log('Notification permission granted.')
      messaging.getToken().then((token) => {
        console.log('New token created: ', token)
        localStorage.setItem("token",token)
        this.saveNotificationToken(token)
      })
    }).catch((err) => {
      console.log('Unable to get permission to notify.', err)
    })

    messaging.onTokenRefresh(function () {
      messaging.getToken().then(function (newToken) {
        console.log('Token refreshed: ', newToken)
        this.saveNotificationToken(newToken)
      }).catch(function (err) {
        console.log('Unable to retrieve refreshed token ', err)
      })
    })

          // if (localStorage.getItem("islogout") !== null) {
          //    this.loginview =true
          //   }
    localStorage.setItem("firstload",0);
    console.log(this.$parent.$children[0].prntsearch)
     this.$parent.$children[0].$children[0].cartlength = this.addedcartitem.length;
    
    },
 
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
  /* margin-bottom: 10px; */
}
#scpr{
  margin-top: 1em;
   padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
